import { render, staticRenderFns } from "./details.vue?vue&type=template&id=5a71a7eb&scoped=true&"
import script from "./details.vue?vue&type=script&lang=ts&"
export * from "./details.vue?vue&type=script&lang=ts&"
import style0 from "./details.vue?vue&type=style&index=0&id=5a71a7eb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a71a7eb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/builds/3ce44491/2/fsi-lab/soft/app/robot-config/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VContainer,VLayout})
